var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-no-data"},[_c('icon',{attrs:{"name":"no-data"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }